module.exports = __webpack_public_path__ + "img/tech-data-squarelogo.8fbd3c04.png";